import { ProTable } from '@ant-design/pro-components'
import { FindingsAlert, FindingsSelector } from '@app/icare/components/findings'
import { PatientCareLevelEditDrawer } from '@app/icare/entities/patient/edits/PatientCareLevelEditDrawer'
import { patientCareLevelQueries } from '@app/icare/entities/patient/queries/patientCareLevelQueries'
import { selectByFindingId } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { CareLevelEnum } from '@app/icare/entities/patient/schema/PatientCareLevel'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { sortByActiveRange } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button, Flex } from 'antd'
import { FaPencil } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/pflegegrad')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientCareLevelQueries.forList(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data: careLevels = [] } = useSuspenseQuery(patientCareLevelQueries.forList(patientId))

  return (
    <Flex vertical gap="small">
      <FindingsSelector selector={selectByFindingId('AnamnesisCareLevelRequired')}>
        {f => <FindingsAlert findings={f} />}
      </FindingsSelector>
      <ProTable
        search={false}
        options={false}
        size="small"
        rowKey="id"
        dataSource={careLevels}
        locale={{ emptyText: t`Keine Pflegegrade vorhanden` }}
        columns={[
          {
            title: t`Pflegegrad`,
            dataIndex: 'level',
            render: (_, r) => CareLevelEnum.$.getLabel(r.level),
          },
          {
            title: t`Gültig von`,
            dataIndex: 'activeFrom',
            valueType: 'date',
            defaultSortOrder: 'descend',
            sorter: sortByActiveRange,
          },
          {
            title: t`Gültig bis`,
            dataIndex: 'activeTo',
            valueType: 'date',
          },
          {
            valueType: 'option',
            render: (_t, r) => [
              <Button
                key="edit"
                type="text"
                size="small"
                icon={<FaPencil />}
                onClick={() => PatientCareLevelEditDrawer.show({ patientId, relationId: r.id })}
              />,
            ],
          },
        ]}
      />
    </Flex>
  )
}
